import { Resource } from './resource';

export class JobComment extends Resource {
  id: String;
  name: String;
  description: String;
  //job id
  job: String;
  //user id
  
}